// @generated

import { decodeHex } from "../common/hex.js"

export default decodeHex(
"\
0061736d01000000011f0560017f027f7e60027f7e017f60047f7e7f7e027f7e\
60017f017f60017f0002100104686f7374066d656d6f72790200010306050001\
020304060c027f0041000b7f0041c0010b0720020d6b656363616b5f72635f61\
647203000c6b656363616b5f663136303000040ab604052500200041086a2000\
29030020002903288520002903508520002903788520002903a001850b4a0020\
0041086a20002000290300200185370300200020002903282001853703282000\
200029035020018537035020002000290378200185370378200020002903a001\
2001853703a0010b18002000200020026a220029030020002001200389370300\
0b7c01057e200041286a20002903002101200029030821022000290310210320\
002903182104200029032021052000200120032002427f858385370300200020\
0220042003427f8583853703082000200320052004427f858385370310200020\
0420012005427f8583853703182000200520022001427f8583853703200bac02\
02017f067e230021010340200010002102100021031000210410002105100021\
061a200020062003420189851001200220044201898510012003200542018985\
100120042006420189851001200520024201898510011a2000200029030841d0\
004201100241384203100241d80042061002418801420a1002419001420f1002\
4118421510024128421c10024180014224100241c000422d100241a801423710\
0241c001420210024120420e100241f800421b100241b8014229100241980142\
38100241e8004208100241e000421910024110422b100241a001423e100241f0\
004212100241b0014227100241c800423d10024130421410024108422c10021a\
1a2000100310031003100310031a200020002903002001290300853703002001\
41086a22012301490d000b0b\
",
)
